<sgt-multi-select
  #multiSelectRef
  [options]="semanasSelectOptions"
  [settings]="settings"
  (search)="onSelectionChange()"
>
</sgt-multi-select>
